
































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import TanggalGizi from "@/components/gizi/TanggalGizi.vue";
import OrderGiziSvc from "@/services/OrderGizi";
import { appModule } from "@/store/modules/app";
import {
  labelShiftOrderGizi,
  SHIFT_ORDER_GIZI,
  shiftSekarang
} from "@/constants/gizi";
import { formatUmur } from "@/utils/gizi";
import {
  BarisFormOrderGizi,
  OrderGizi,
  OrderGiziPayload,
  ShiftOrderGizi
} from "@/types/orderGizi";

@Component({
  components: { TanggalGizi }
})
export default class OrderGiziFormDialog extends Vue {
  @Prop({ type: Boolean, default: false }) readonly value!: boolean;
  @Prop({ type: String, required: true }) readonly unitId!: string;
  @Prop({ type: String, default: "" }) readonly unitNama!: string;
  @Prop({ default: null }) readonly order!: OrderGizi | null;

  tanggal = "";
  shift: ShiftOrderGizi = "pagi";
  catatan = "";
  baris: BarisFormOrderGizi[] = [];
  terpilih: BarisFormOrderGizi[] = [];
  diitOpsi: string[] = [];
  cari = "";
  memuat = false;
  menyimpan = false;
  siap = false;
  pesanGalat = "";
  sudahCobaSimpan = false;
  tokenMuat = 0;

  readonly headers = [
    { text: "No. RM", value: "pasien_rm", width: "90" },
    { text: "Nama Pasien", value: "pasien_nama" },
    { text: "Ruang", value: "ruang", width: "120" },
    { text: "Diit", value: "diit", width: "320", sortable: false },
    { text: "Keterangan", value: "keterangan", width: "240", sortable: false }
  ];

  get shiftOptions() {
    return SHIFT_ORDER_GIZI.map(s => ({
      value: s.value,
      text: `${s.text} (${s.jam})`
    }));
  }

  get labelShift(): string {
    return labelShiftOrderGizi(this.shift);
  }

  get jumlahSudahDipesan(): number {
    return this.baris.filter(b => !b.bisa_dipilih).length;
  }

  @Watch("value", { immediate: true })
  async onBuka(buka: boolean) {
    if (!buka) return;

    this.siap = false;
    this.pesanGalat = "";
    this.sudahCobaSimpan = false;
    this.cari = "";

    if (this.order) {
      this.tanggal = this.order.tanggal;
      this.shift = this.order.shift;
      this.catatan = this.order.catatan || "";
    } else {
      const sekarang = shiftSekarang();
      this.tanggal = sekarang.tanggal;
      this.shift = sekarang.shift;
      this.catatan = "";
    }

    await this.muat(true);
    this.siap = true;
  }

  @Watch("tanggal")
  @Watch("shift")
  onGantiSlot() {
    if (this.siap && this.value) {
      this.muat(false);
    }
  }

  async muat(awal: boolean) {
    if (!this.unitId || !this.tanggal) return;

    const token = ++this.tokenMuat;
    const lama: Record<string, BarisFormOrderGizi> = {};
    this.baris.forEach(b => {
      lama[b.register_id] = b;
    });
    const terpilihLama = new Set(this.terpilih.map(b => b.register_id));

    this.memuat = true;
    try {
      const res = await OrderGiziSvc.pasienBangsal({
        unit_id: this.unitId,
        tanggal: this.tanggal,
        shift: this.shift,
        order_id: this.order ? this.order.id : null
      });
      if (token !== this.tokenMuat) return;

      const baru: BarisFormOrderGizi[] = res.data.map(row => {
        const sebelumnya = !awal ? lama[row.register_id] : undefined;
        return {
          ...row,
          diit: sebelumnya ? sebelumnya.diit : row.diit || "",
          keterangan: sebelumnya ? sebelumnya.keterangan : row.keterangan || "",
          bisa_dipilih: !row.sudah_dipesan
        };
      });

      this.diitOpsi = res.diit_opsi || [];
      this.baris = baru;
      this.terpilih = baru.filter(row => {
        if (!row.bisa_dipilih) return false;
        const sebelumnya = lama[row.register_id];
        if (awal || !sebelumnya || !sebelumnya.bisa_dipilih) return row.dipilih;
        return terpilihLama.has(row.register_id);
      });
    } finally {
      if (token === this.tokenMuat) {
        this.memuat = false;
      }
    }
  }

  saringBaris(_value: unknown, search: string | null, item: BarisFormOrderGizi) {
    const cari = (search || "").toLowerCase().trim();
    if (!cari) return true;

    return (
      String(item.pasien_nama || "").toLowerCase().includes(cari) ||
      String(item.pasien_rm || "").includes(cari)
    );
  }

  jkUmur(item: BarisFormOrderGizi): string {
    return [item.sex, formatUmur(item.umur)].filter(v => !!v).join(" · ");
  }

  diitKosong(item: BarisFormOrderGizi): boolean {
    return (
      this.sudahCobaSimpan &&
      this.terpilih.some(t => t.register_id === item.register_id) &&
      !String(item.diit || "").trim()
    );
  }

  async simpan() {
    this.pesanGalat = "";
    this.sudahCobaSimpan = true;

    if (!this.terpilih.length) {
      this.pesanGalat = "Pilih minimal satu pasien.";
      return;
    }

    const tanpaDiit = this.terpilih.filter(b => !String(b.diit || "").trim());
    if (tanpaDiit.length) {
      this.pesanGalat = `Diit belum diisi untuk ${tanpaDiit.length} pasien: ${tanpaDiit
        .map(b => b.pasien_nama)
        .join(", ")}.`;
      return;
    }

    const payload: OrderGiziPayload = {
      unit_id: this.unitId,
      tanggal: this.tanggal,
      shift: this.shift,
      catatan: this.catatan.trim() || null,
      items: this.terpilih.map(b => ({
        register_id: b.register_id,
        diit: String(b.diit).trim(),
        keterangan: String(b.keterangan || "").trim() || null
      }))
    };

    this.menyimpan = true;
    try {
      const tersimpan = await OrderGiziSvc.simpan(
        payload,
        this.order ? this.order.id : null
      );
      appModule.NoticeDelay(
        `Pesanan makanan shift ${this.labelShift} untuk ${payload.items.length} pasien tersimpan`
      );
      this.$emit("tersimpan", tersimpan);
      this.$emit("input", false);
    } catch {
      return;
    } finally {
      this.menyimpan = false;
    }
  }

  tutup() {
    if (this.menyimpan) return;
    this.$emit("input", false);
  }
}
